module.exports = __webpack_public_path__ + "img/Frame Logo Tablet.20f6cd8e.webp";